import MiniShoppingCart from "components/mini-shopping-carts/MiniShoppingCart";

export default {
    extends: MiniShoppingCart,
    props: {
        jqueryEvents: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        if (this.jqueryEvents) {
            this.initJQueryEvents();
        }

        if (document.querySelector('.search-cate-child')) {
            $("#menu3_search_form").searchBar({
                dropDownItemContainer: ".search-cate-child",
                dropDownItem: ".category_item"
            });
        }

        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                $('.header-bottom.sticky-content').addClass("fixed");
                $('.header-middle.sticky-content').addClass("fixed");
                $('.right-cart-btn-wrapper').addClass("show");
            } else {
                $('.header-bottom.sticky-content').removeClass("fixed");
                $('.header-middle.sticky-content').removeClass("fixed");
                $('.right-cart-btn-wrapper').removeClass("show");
            }
        });
    },
    watch: {
        showCart(newValue) {
            if (newValue) {
                $('#fb-root').hide();
            } else {
                $('#fb-root').show();
            }
        },
    },
    methods: {
        initJQueryEvents() {
            $(document).on("click", ".cart-toggle", () => {
                this.showCart = true;
            });

            $(document).on("click", ".cart-close, .cart-offcanvas .cart-overlay", () => {
                this.showCart = false;
            });

            $('.mobile-menu-toggle').on("click", () => {
                $('body').addClass('mmenu-active');
                $('#fb-root').hide();
            });

            $('.mobile-menu-close, .mobile-menu-wrapper .mobile-menu-overlay').on("click", () => {
                $('body').removeClass('mmenu-active');
                $('#fb-root').show();
            });

            $(document).on("click", ".msearch-swt", function () {
                $('.mobile-view-search').toggleClass('show');
            });

            $('.toggle-btn').on("click", function (e) {
                e.preventDefault();
                $(this).parent().next().slideToggle(300).parent().toggleClass("show");
            });
        }
    }
};
